// extracted by mini-css-extract-plugin
export default {"delete-modal-message":"DeleteModal_delete-modal-message__oulFr"};